import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import WarningIcon from 'assets/images/error-icon.svg';
import CloseIcon from 'assets/images/cross-icon.svg';
import './style.css';
import style from './style';
import { globalStyles } from 'shared/constants';

// TODO: Refactor this and bulk upload to remove these default values
// from this component and pass it from bulk upload.
export default ({
  heading = 'Error Detected',
  headingClassName = null,
  content = null,
  actionLabel = 'Close',
  errorKey,
  errorData,
  showModel,
  onClose,
  title = 'Oops! Conductor encountered an error. Please read the message below for details.',
  headers = null,
  errorBody = null,
  errorMessage = 'Duplicate data found',
  wrapperClassName = null,
  onCancel,
  actionLabelClass = null,
  titleBackground = 'bg-danger',
  hasCloseIcon = true,
  gridHeaderClass = '',
}) => {
  let gridBody = [];
  if (!headers) {
    headers = [`${errorKey}:`, 'Rows'];
  }

  if (errorData) {
    for (const key in errorData) {
      gridBody.push(
        <tr key={key}>
          <td className='pb-2 color-text-primary'>{key}</td>
          <td className='color-text-primary'>{errorData[key].join(', ')}</td>
        </tr>
      );
    }
  }

  if (errorBody) {
    errorBody.forEach((element, index) => {
      gridBody.push(
        <tr key={`${element} - ${index}`}>
          <td className='color-text-secondary'>
            <Typography variant='body2'>{element}</Typography>
          </td>
        </tr>
      );
    });
  }

  return (
    <Dialog
      sx={{
        ...style.errorWrapper
      }}
      className='error-modal-wrapper'
      open={showModel}
      onClose={onCancel || onClose}
      centered
    >
      <DialogContent>
        <Box>
          <Box
            sx={{
              ...globalStyles.display.flex,
              ...globalStyles.flex.justify.end,
              ...globalStyles.flex.align.center,
              ...globalStyles.padding(1),
              ...style.titleWrapper
            }}
          >
            <Box
              sx={{ ...globalStyles.cursor.pointer }}
              onClick={onClose}
            >
              <img alt='Close Icon' src={CloseIcon} />
            </Box>
          </Box>
          <Box
            sx={{
              ...globalStyles.display.flex,
              ...globalStyles.flex.direction.column,
              ...globalStyles.flex.justify.center,
              ...globalStyles.flex.align.center,
              ...globalStyles.padding(1, 'Top'),
              ...globalStyles.padding(5, 'Right'),
              ...globalStyles.padding(5, 'Left'),
              ...style.titleWrapper
            }}
          >
            <Typography variant='h5' sx={{ ...globalStyles.text.weight.bold, ...globalStyles.text.color.black   }}>{heading}</Typography>
            <Box sx={{ mt: 4 }}>
              <img alt='Wrning Icon' src={WarningIcon} height={64} />
            </Box>
          </Box>
        </Box>
        <Box
          className='content-wrapper txt'
          sx={{
            ...style.contenWrapper
          }}
        >
          {content ? (
            <>{content}</>
          ) : (
            <>
              <Typography
                variant='body2'
                sx={{px: 4, ...style.errorTitle, ...globalStyles.text.align.center }}
              >
                {title}
              </Typography>
              <Box className='error-txt'>
                {errorMessage && (
                  <Box
                    sx={{
                      ...globalStyles.display.flex,
                      ...globalStyles.flex.justify.center,
                    }}
                  >
                    <Typography
                      variant='body1'
                      sx={{ ...globalStyles.text.weight.bold, ...globalStyles.text.align.center, ...globalStyles.text.color.error }}
                    >
                      Error:
                    </Typography>
                    <Typography
                      variant='body1'
                      sx={{
                        ...globalStyles.text.align.center,
                        ...globalStyles.text.weight.bold,
                        ...globalStyles.margin(1, 'Left'),
                      }}
                    >
                      {errorMessage}
                    </Typography>
                  </Box>
                )}
              </Box>
              <Box
                className='grid-error-wrapper'
                sx={{
                  ...style.gridErrorWrapper,
                }}
              >
                <table className='grid-error'>
                  <thead>
                    <tr className='color-text-primary'>
                      {headers.map(header => (
                        <th className='color-text-primary'>{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className='color-text-secondary'>{gridBody}</tbody>
                </table>
              </Box>
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Box
          sx={{
            ...globalStyles.width["100"],
            ...globalStyles.padding(2, 'Right'),
            ...globalStyles.padding(6, 'Bottom'),
            ...globalStyles.display.flex,
            ...globalStyles.flex.justify.center,
          }}
        >
          <Button
            variant='contained'
            color='primary'
            onClick={onClose}
          >
            {actionLabel}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
